import apiClient from './client';

export interface CallToAction {
  text: string;
  link: string;
}

export interface FeaturedArticle {
  id: number;
  title: string;
  subtitle?: string;
  author: string;
  publishedAt: string;
  excerpt: string;
  content: string;
  imageUrl?: string;
  readTime: string;
  tags: string[];
  personalized: boolean;
  cta?: CallToAction;
}

/**
 * Fetch the featured article
 */
export async function fetchFeaturedArticle(): Promise<FeaturedArticle> {
  const response = await apiClient.get<FeaturedArticle>('/api/content/featured-article');
  return response.data;
}

/**
 * Fetch article by ID (future use)
 */
export async function fetchArticle(id: number): Promise<FeaturedArticle> {
  const response = await apiClient.get<FeaturedArticle>(`/api/content/articles/${id}`);
  return response.data;
}